export const sortString = (first, second) => {
  let fa = first.toLowerCase(),
    fb = second.toLowerCase();
  if (fa < fb) return -1;
  if (fa > fb) return 1;
  return 0;
};
